// https://developers.google.com/tag-manager/devguide

import config from './utils/config';
import { googleAnalyticsHasMounted } from './utils/event-dispatchers';
import { whenProfileLoaded } from './utils/event-listeners';

if (!Array.isArray(window.dataLayer)) {
    window.dataLayer = [];
}

window._assets_loaded_google_tag_manager = true;

function mountGoogleTagManagerScript(onload) {
    // Google Tag Manager
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var firstScriptTag = d.getElementsByTagName(s)[0],
            gaScriptTag = d.createElement(s),
            _dataLayer = l != 'dataLayer' ? '&l=' + l : '';
        gaScriptTag.async = true;
        gaScriptTag.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + _dataLayer;
        gaScriptTag.onload = function () {
            setTimeout(() => {
                onload()
            }, 100);
        }
        firstScriptTag.parentNode.insertBefore(gaScriptTag, firstScriptTag);
    })(window, document, 'script', 'dataLayer', 'GTM-T6TDJSD');
    // End Google Tag Manager
}

whenProfileLoaded(profile => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'region': profile.region || 'unknown',
    });
    let visitorLoggedInData = {};
    if (profile.is_logged_in) {
        visitorLoggedInData = {
            loggedIn: 'true',
            loggedInStatus: 'logged in',
        };
    } else if (!profile.is_logged_in && profile.customer_id && profile.customer_id != '0') {
        visitorLoggedInData = {
            loggedIn: 'false',
            loggedInStatus: 'half logged in',
        };
    } else {
        visitorLoggedInData = {
            loggedIn: 'false',
            loggedInStatus: 'logged out',
        };
    }

    const visitorData = [
        {
            visitorId: profile.customer_id || '',
        },
        {
            internal: profile.role == 'internal' ? '1' : '0',
        },
        {
            visitortype: profile.email ? 'known' : 'unknown',
        },
        visitorLoggedInData
    ];

    dataLayer.push(...visitorData);

    if(profile.relationshipmeter){
        dataLayer.push({
            rship: profile.relationshipmeter.score,
            rshipc: profile.relationshipmeter.color
        });
    }

    if (profile.email && Object.keys(profile.email).length > 0) {
        dataLayer.push(
            { "email_address": profile.email },
            { "hashed_email": profile.hashed_email },
            { "hashed_email2": profile.hashed_email2 },
            { "hashed_email3": profile.hashed_email3 }
        );
    }

    if (profile.eventID) {
        dataLayer.push({ 'pageViewEventID': profile.eventID });
    }

    if (profile.emailable !== undefined) {
        dataLayer.push({
            emailable: profile.emailable ? '1' : '0',
        });
    }

    mountGoogleTagManagerScript(() => {

        if (!document.referrer.includes('sweetwater.')) {
            dataLayer.push({ landing: 'true' });
        }

        // Run our custom google analytics hook.
        // All `ga()` calls by applications using the header/footer
        // service should call them in the callback of the
        // `$sw.eventListeners.whenGoogleAnalyticsHasMounted` function.
        // Doing it this way ensures that all client application events
        // happen before the events that happen after this function call.
        googleAnalyticsHasMounted();
    });
});
